import { CareerCenterServicePath } from "utils/constants";

export const careerCenterRequests = {
  returnForCorrectionEmployer: id => `${CareerCenterServicePath}employers/${id}/corrections`,
  returnForCorrectionJobOffer: id => `${CareerCenterServicePath}job-offers/${id}/corrections`,
  activateEmployerProfile: id => `${CareerCenterServicePath}employers/${id}/activate`,
  approveJobOffer: id => `${CareerCenterServicePath}job-offers/${id}/activate`,
  rejectEmployer: id => `${CareerCenterServicePath}employers/${id}/reject`,
  rejectJobOffer: id => `${CareerCenterServicePath}job-offers/${id}/reject`,
  changeStatusEmployer: id => `${CareerCenterServicePath}employers/${id}/status`,
  changeStatusJobOffer: id => `${CareerCenterServicePath}job-offers/${id}/status`,
  correctionHistoryEmployer: id => `${CareerCenterServicePath}employers/${id}/corrections/history`,
  correctionHistoryJobOffer: id => `${CareerCenterServicePath}job-offers/${id}/corrections/history`,

  getStatusesSelect: () => `${CareerCenterServicePath}selects/statuses`,
  getCustomStatusesSelect: () => `${CareerCenterServicePath}selects/custom-statuses`,
  getJobOfferTypesSelect: () => `${CareerCenterServicePath}selects/job-offer-types`,
  getJobCategoryTypesSelect: () => `${CareerCenterServicePath}selects/job-category-types`,
  getJobOffersCandidateTypesSelect: () => `${CareerCenterServicePath}job-offers/candidate-types`,
  getEmploymentTypesSelect: () => `${CareerCenterServicePath}selects/employment-types`,
  getContractTypesSelect: () => `${CareerCenterServicePath}selects/contract-types`,
  getJobApplicationMethodsSelect: () => `${CareerCenterServicePath}selects/job-application-methods`,
};
